export default function getTheme() {
  return require(`./botTheme.json`);
}
